module.exports = __webpack_public_path__ + "img/echalotte_en_bac.4e146d0a.jpeg";